//-- Copyright (c) 2021 TMT Insights Group, LLC
import OverflowMenu from '@/components/_common/OverflowMenu/OverflowMenu';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import PolarisIcon from '@/components/_common/PolarisIcon';
import useDeleteTemplateConfirmation from '@/components/Packaging/hooks/useDeleteTemplateConfirmation';
import { useAppDispatch } from '@/redux/hooks';
import { getData } from '@/redux/slices/dataTableSlice';
import { AssemblyTemplate } from '@/redux/slices/packagingSlice.types';
import { useHistory } from 'react-router-dom';
import { useToast } from '../_common/Toast';
import AssemblyTemplateActionButton from '../Packaging/AssemblyTemplateActionButton';

type AssemblyTemplatesOverflowMenuProps = {
  row: AssemblyTemplate;
};

const AssemblyTemplatesOverflowMenu = ({ row }: AssemblyTemplatesOverflowMenuProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { success } = useToast();

  const { deleteTemplateDialog, openDialog: openDeleteTemplateDialog } = useDeleteTemplateConfirmation({
    onDeleted: () => {
      success('Template deleted successfully');
      dispatch(getData());
    }
  });

  const handleEdit = () => {
    history.push(`/assembly-templates/edit/${row.id}`);
  };

  return (
    <>
      {deleteTemplateDialog}
      <OverflowMenu>
        <OverflowMenuItem onClick={handleEdit}>
          <PolarisIcon icon="edit" height={15} />
          Edit
        </OverflowMenuItem>
        <AssemblyTemplateActionButton
          defaultName={row.name + ' (Copy)'}
          defaultType={row.template_type}
          creationMode="duplicate"
          overflow
          timeline={row.data}
        />
        <OverflowMenuItem onClick={() => openDeleteTemplateDialog(row.id)}>
          <PolarisIcon icon="delete" height={15} />
          Delete
        </OverflowMenuItem>
      </OverflowMenu>
    </>
  );
};

export default AssemblyTemplatesOverflowMenu;
